exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-content[data-v-51639c58]{\n    position: relative;\n    padding: 0 20px;\n    width:100%;\n    overflow-x: auto;\n    height: 200px;\n}\n@media (max-width: 992px){\n.list-mobile[data-v-51639c58] {\n    display: block;\n    height: 350px;\n}\n}\np.title[data-v-51639c58]{\n  padding-top: 8px;\n  font-size: 24px;\n  padding-bottom: 5px;\n}\n", ""]);

// exports
